var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Quill from 'quill';
import { MediaAsset } from 'packages/media/MediaAsset';
var playIcon = require('common/UIToolKit/icons/play-circle.svg?raw');
var embed = Quill.import('blots/embed');
var coverStyles = 'absolute flex items-center justify-center w-full h-full bg-charcoal bg-opacity-20 top-0 left-0 text-white';
var iconStyles = 'h-10 w-10 fill-current';
var VideoAssetEmbed = /** @class */ (function (_super) {
    __extends(VideoAssetEmbed, _super);
    function VideoAssetEmbed() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VideoAssetEmbed.create = function (asset) {
        var _a, _b;
        var node = _super.create.call(this);
        node.classList.add('relative');
        node.setAttribute('data-type', asset.type);
        node.setAttribute('data-id', "" + asset.id);
        var vid = document.createElement('video');
        vid.setAttribute('src', asset.uri);
        vid.classList.add('w-full', 'relative');
        var cover = document.createElement('div');
        (_a = cover.classList).add.apply(_a, coverStyles.split(' '));
        var icon = document.createElement('div');
        icon.innerHTML = playIcon;
        (_b = icon.classList).add.apply(_b, iconStyles.split(' '));
        cover.appendChild(icon);
        node.appendChild(vid);
        node.appendChild(cover);
        return node;
    };
    VideoAssetEmbed.value = function (node) {
        var asset = new MediaAsset();
        asset.id = parseInt(node.getAttribute('data-id'));
        asset.type = node.getAttribute('data-type');
        var video = node.querySelector('video');
        asset.uri = video.getAttribute('src');
        return asset;
    };
    VideoAssetEmbed.blotName = 'VideoAssetEmbed';
    VideoAssetEmbed.className = 'ql-video-asset';
    VideoAssetEmbed.tagName = 'div';
    return VideoAssetEmbed;
}(embed));
export { VideoAssetEmbed };
